import React from "react";
import PropTypes from "prop-types";
import BaseAnchor from "../Anchor/BaseAnchor";
import "./breadcrumb.scss";

const Breadcrumb = ({ links }) => {
  return (
    <div>
      <ul className="breadcrumb">
        {links.map((link, i) => {
          return (
            <li key={i}>
              <BaseAnchor to={link.to}>{link.text}</BaseAnchor>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

Breadcrumb.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
    })
  ),
};

export default Breadcrumb;
